export const allAuthTypeOptions = [
  { label: "Oncology", value: "Oncology" },
  { label: "Primary Care", value: "Primary Care" },
  { label: "Rheumatology", value: "Rheumatology" },
];
